import "moment/locale/ar"; // Import Arabic locale
import { useNavigate } from "react-router-dom";

const AnsweredItem = ({ post }) => {
  const navigate = useNavigate();
  const poster_image =
    process.env.REACT_APP_API_URL +
    `${post?.avatar_template?.replace("{size}", "100")}`;
  return (
    <div
      onClick={() => {
        navigate(`/detail/${post.topic_id}`);
      }}
      className="px-4 flex flex-col w-full py-5 bg-white border rounded-2xl mb-2"
      style={{ boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.06)" }}
    >
      <div className="p-4 pb-0">
        <div className="flex items-start mb-4">
          <div className="flex justify-between w-full">
            <div className="flex justify-between w-full">
              <div className="flex gap-3" alt="">
                <img
                  src={poster_image}
                  alt=""
                  className="w-[30px] h-[30px] sm:w-[44px] sm:h-[44px] rounded-full"
                  onClick={(event) => {
                    event.stopPropagation();
                    navigate("/profile", {
                      state: {
                        username: post?.acting_username,
                        id: post?.acting_user_id,
                      },
                    });
                  }}
                />

                <div className="flex-col">
                  <div className="flex sm:hidden">
                    {post.has_accepted_answer && (
                      <div className="bg-[#EFFBF6] rounded-full w-[7rem] sm:w-auto">
                        <div className="flex gap-2 px-3">
                          <img src="/images/home/tick.svg" alt="" />
                          <span className="text-[#008C56] font-medium mt-[3px]">
                            تم الاجابة
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="bg-[#EFFBF6] rounded-full w-[7rem]">
                    <div className="flex gap-2 px-3">
                      <img src="/images/home/tick.svg" alt="" />
                      <span className="mb-1 text-[#008C56] font-medium mt-[3px]">
                        تم الاجابة
                      </span>
                    </div>
                  </div>
                  <p className="font-bold">{post?.title} </p>
                  <div
                    className="content text-right text-[#707070] mb-4 mt-3 ellipsis"
                    dangerouslySetInnerHTML={{ __html: post?.excerpt || "" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AnsweredItem;
